// resources/assets/js/views/modules/read-more.js

export function initReadMore() {
    const containers = document.querySelectorAll('[data-read-more]');

    containers.forEach(container => {
        const description = container.querySelector('.description');
        const btn = container.querySelector('[data-read-more-btn]');

        if (!description || !btn) return;

        const paragraphs = description.querySelectorAll('p');

        if (paragraphs.length > 1) {
            btn.style.display = 'inline-block';

            btn.addEventListener('click', (e) => {
                e.preventDefault();
                container.classList.toggle('is-open');
            });
        } else {
            btn.style.display = 'none';
        }
    });
}